/**
 * @file     useAntiSpam.ts
 * @readme   ./CLAUDE.md
 * @purpose  Combined anti-spam hook for forms, wraps honeypot + timing into a single integration point.
 */
'use client';

import { useHoneypot } from './honeypot';
import { useSpamTiming } from './timing';

export interface AntiSpamMetadata {
  honeypotFilled: boolean;
  elapsedSeconds: number;
  submissionTooFast: boolean;
}

export function useAntiSpam(minSeconds: number = 3) {
  const { setHoneypotValue, isBot } = useHoneypot();
  const { isTooFast, getElapsedSeconds } = useSpamTiming(minSeconds);

  function getAntiSpamMetadata(): AntiSpamMetadata {
    return {
      honeypotFilled: isBot(),
      elapsedSeconds: getElapsedSeconds(),
      submissionTooFast: isTooFast(),
    };
  }

  function shouldRejectClient(): boolean {
    return isBot();
  }

  return {
    setHoneypotValue,
    getAntiSpamMetadata,
    shouldRejectClient,
  };
}
